import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import GraphQL from '../../../GraphQL';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import SmartCard from '../../../shared/components/SmartCard';
import EvaluationWayForm from './Form';
import {
  evaluationWayListByFilter,
  evaluationWaySave,
} from '../../../shared/queries/EvaluationWay';

const EvaluationWayFormHandler = (props) => {
  const { dispatch, t, history, match } = props;

  const [formOn, setFormOn] = useState(false);
  const [dto, setDto] = useState({ id: 0, active: true });

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const backClickHandler = () => {
    history.push('/minime/instrumento-avaliacao');
  };

  const handleSubmit = (values) => {
    showLoading();
    const mutationQuery = evaluationWaySave(values);
    GraphQL(mutationQuery, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
        backClickHandler();
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-save')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  function findById(id) {
    showLoading();
    const filter = {
      filterByStatus: false,
      updaterId: 0,
      active: true,
      id,
    };
    const query = evaluationWayListByFilter(filter);
    GraphQL(query, {})
      .then((res) => {
        if (res.evaluationWayListByFilter) {
          setDto({
            ...res.evaluationWayListByFilter[0],
          });
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
          backClickHandler();
        }
      })
      .catch((error) => {
        if (error.response) {
          showNotificationAutoDestroy(
            'danger',
            t('errors.title'),
            t('errors.error-to-loading')
          );
        }
      })
      .finally(() => {
        hideLoading();
      });
  }

  useEffect(() => {
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        findById(match.params.id);
      } else {
        setFormOn(true);
      }
    } else {
      setFormOn(true);
    }
  }, [dto]);

  return (
    <SmartCard title={t('panels.instrumento-avaliacao')}>
      {formOn ? (
        <EvaluationWayForm
          onSubmit={handleSubmit}
          backHandler={backClickHandler}
          dto={dto}
        />
      ) : null}
    </SmartCard>
  );
};

EvaluationWayFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.func.isRequired,
  match: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(EvaluationWayFormHandler)
);
